import { render, staticRenderFns } from "./business-form.vue?vue&type=template&id=f7e481ac"
import script from "./business-form.vue?vue&type=script&lang=js"
export * from "./business-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports